import { decryptId } from "../../../Components/CryptoComponent";
import AddLookup from "../../../Components/InputComponents/AddLookup";
import { useParams, useSearchParams } from "react-router-dom";

function EditEmploymentType() {
  const { id } = useParams();
  const decryptedId = decryptId(decodeURIComponent(id));

  const [searchParams] = useSearchParams();
  const redirectURL = `/EmploymentTypeLookup?${searchParams.toString()}`;

  return (
    <AddLookup
      title="Edit Employment Type"
      alert="Employment Type Edited Successfully"
      editDataAPIEndPoint={`/EmpStatus/Edit/${decryptedId}`}
      viewDataDetailsAPIEndPoint={`/EmpStatus/listbyId/${decryptedId}`}
      redirectURL={redirectURL}
      sections={[
        {
          fields: [
            {
              type: "text",
              label: "Employment Type",
              name: "ES_Name",
              required: true, // Validation rule added here
               maxLength:70
            },
            {
              type: "select",
              label: "Status",
              name: "ES_Status",
              required: true, // Validation rule added here
                            options: [
                { label: "Active", value:'1'},
                { label: "Inactive", value: '0'},
              ],
            },
          ],
        },
      ]}
      validationRules={{
        ES_Name: {
          required: true,
          
        },
        ES_Status: {
          required: true,
        },
      }}
    />
  );
}

export default EditEmploymentType;
